export const DetailsComponentTabsData = [
  { tab: 'Related-Communities' },
  { tab: 'Related-SubCommunities' }
];
